export default "__VITE_ASSET__3bc48e44__"